import styles from "./servicos-cover.module.css";
import coverImg from "../../../images/_finais/servicos-cover_compress.webp";

const ServicosCover = () => {
  return (
    <section className={styles.cover_section}>
      <div className={styles.title_div}>
        <h1 className={styles.title}>NOSSOS PRODUTOS</h1>
        <span className={styles.line}></span>
      </div>
      <img
        className={styles.coverImg}
        src={coverImg}
        alt="Cover da página Home."
        loading="lazy"
      />
    </section>
  );
};

export default ServicosCover;
